/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from "react";
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  // IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Skeleton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Breadcrumbs,
  Snackbar,
  Alert,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import "./Taxonomy.css";

import useFetchWithMsal from "hooks/useFetchWithMsal";

// dialog box
import { Link, useLocation, useNavigate } from "react-router-dom";

import { v4 as uuidv4 } from "uuid";

// edit button
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { protectedResources, siteData } from "../../authConfig";
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/projectIcons/Component 207 – 45.svg";

// implement stepper steps
const steps = ["Taxonomy Details", "Add Risk and sub categories", "Review and Save"];

// 4-point risk appetite scale per Level 2 (TX-03)
const APPETITE_OPTIONS = [
  "Risk aversion",
  "Balanced risk aversion",
  "Balanced opportunity",
  "Opportunity",
];

// Map legacy/different appetite values to current options for backward compatibility
const LEGACY_APPETITE_MAP = {
  "Risk Averse": "Risk aversion",
  "Risk aversion": "Risk aversion",
  "Risk Balanced": "Balanced risk aversion",
  "Balanced risk aversion": "Balanced risk aversion",
  "Risk Seeking": "Opportunity",
  "Balanced opportunity": "Balanced opportunity",
  Opportunity: "Opportunity",
};

const getAppetiteSelectValue = (value) => {
  if (!value) return "";
  if (APPETITE_OPTIONS.includes(value)) return value;
  return LEGACY_APPETITE_MAP[value] || "";
};

// ID139 — legacy appetite value (lowercase) → the default level-title bucket (lowercase), so old
// data resolves to the configured levels even when titles differ (e.g. "Opportunity Seeking").
const APPETITE_TITLE_ALIAS = {
  "risk aversion": "risk aversion",
  "risk averse": "risk aversion",
  "balanced risk aversion": "balanced risk aversion",
  "risk balanced": "balanced risk aversion",
  "balanced opportunity": "balanced opportunity",
  opportunity: "opportunity seeking",
  "opportunity seeking": "opportunity seeking",
  "risk seeking": "opportunity seeking",
};

// ID13 — risk appetite colour scale (risk-averse → opportunity-seeking).
const APPETITE_COLOR = {
  "Risk aversion": "#d32f2f",
  "Balanced risk aversion": "#f57c00",
  "Balanced opportunity": "#fbc02d",
  Opportunity: "#388e3c",
};

/**
 * Returns owner value for Select only if it exists in ownerUsers (prevents MUI out-of-range error
 * when existing data has placeholder like "Owner" or removed user email).
 */
const getOwnerSelectValue = (owner, ownerUsers) => {
  if (!owner || !String(owner).trim()) return "";
  const ownerLower = String(owner).trim().toLowerCase();
  const found = ownerUsers?.find((u) => (u.email || "").toLowerCase() === ownerLower);
  return found ? found.email : "";
};

const getOwnerDisplayName = (ownerEmail, ownerUsers) => {
  if (!ownerEmail) return "";
  const u = ownerUsers?.find(
    (x) => (x.email || "").toLowerCase() === String(ownerEmail).toLowerCase()
  );
  if (!u) return ownerEmail;
  const first = u.firstName || "";
  const last = u.lastName || "";
  if (first || last) return [first, last].filter(Boolean).join(" ").trim();
  return u.name || u.email || ownerEmail;
};

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 13,
  },
}));
function ConfigureTaxonomy() {
  const location = useLocation();
  const Primaryid = location.state.categoryId;
  const Tid = location.state.taxonomyId;

  const { execute } = useFetchWithMsal({
    scopes: [siteData?.apiScopes],
  });
  const taxonomyDetailsFetchedFor = useRef(null);
  const currencyListFetched = useRef(false);

  const [currency, setCurrency] = useState("");
  // get the single taxonomy that is clicked in overview page
  const [SingleTaxonomy, setSingleTaxonomy] = useState(null);
  const [noData, setNoData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // ID139 — the Appetite dropdown options + colours come from the configured Risk Appetite Levels.
  const [appetiteLevels, setAppetiteLevels] = useState([]); // [{ title, color, order }]
  const appetiteLevelsFetched = useRef(false);
  useEffect(() => {
    if (appetiteLevelsFetched.current) return;
    appetiteLevelsFetched.current = true;
    execute("GET", `${protectedResources.apiTodoList.endpoint}/appetite-levels/config`)
      .then((res) => {
        const lv = (res?.data?.levels || res?.levels || [])
          .slice()
          .sort((a, b) => (a.order || 0) - (b.order || 0));
        if (lv.length) setAppetiteLevels(lv);
      })
      .catch(() => {});
  }, [execute]);
  const appetiteOptions = appetiteLevels.length
    ? appetiteLevels.map((l) => l.title).filter(Boolean)
    : APPETITE_OPTIONS;
  // Map a stored appetite value (legacy scale OR a level title) to one of the current options.
  const resolveAppetiteOption = (value) => {
    const v = String(value || "").trim();
    if (!v) return "";
    const direct = appetiteOptions.find((o) => o.toLowerCase() === v.toLowerCase());
    if (direct) return direct;
    const alias = APPETITE_TITLE_ALIAS[v.toLowerCase()];
    if (alias) {
      const m = appetiteOptions.find((o) => o.toLowerCase() === alias);
      if (m) return m;
    }
    return getAppetiteSelectValue(v); // legacy fallback
  };
  const appetiteColorFor = (value) => {
    const opt = resolveAppetiteOption(value);
    const lvl = appetiteLevels.find(
      (l) => String(l.title || "").toLowerCase() === String(opt).toLowerCase()
    );
    return (
      (lvl && lvl.color) || APPETITE_COLOR[getAppetiteSelectValue(value)] || "rgba(0,0,0,0.23)"
    );
  };
  useEffect(() => {
    if (Tid && taxonomyDetailsFetchedFor.current !== Tid) {
      taxonomyDetailsFetchedFor.current = Tid;
      execute("GET", `${protectedResources.apiTodoList.endpoint}/taxonomy/details/${Tid}`)
        .then((response) => {
          if (response && response.success === true && response.data?.length > 0) {
            setSingleTaxonomy(response.data);
            setIsLoading(false);
          } else if (
            response &&
            response.success === true &&
            (!response.data || response.data.length === 0)
          ) {
            setNoData(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        })
        .catch(() => setIsLoading(false));
    } else if (!Tid) {
      setNoData(true);
    }

    if (!currencyListFetched.current) {
      currencyListFetched.current = true;
      execute("GET", `${protectedResources.apiTodoList.endpoint}/common/currencylist`).then(
        (response) => {
          if (response && response.success === true && response.data.length > 0) {
            setCurrency(response.data);
          }
        }
      );
    }
  }, [execute, Tid]);

  // Taxonomy object
  const [Taxonomy, setTaxonomy] = useState({});
  // const initialCountryName =
  //   (currency &&
  //     currency.find((option) => option.countryCode === Taxonomy.countryCode)?.countryName) ||
  //   "";

  //   Category object
  const [Categories, setCategories] = useState([]);

  const [Isdisable] = useState(!!Primaryid);
  useEffect(() => {
    if (SingleTaxonomy) {
      setTaxonomy({
        id: SingleTaxonomy[0].id,
        Taxo_Name: SingleTaxonomy[0].name,
        Taxo_Desc: SingleTaxonomy[0].description,
        countryCode: SingleTaxonomy[0].countryCode,
        evaluationPeriod: SingleTaxonomy[0].evaluationPeriod,
      });

      setCategories(
        (SingleTaxonomy[0].Categories || []).map((cat) => ({
          ...cat,
          SubCategories: (cat.SubCategories || []).map((sub) => ({
            ...sub,
            Appetite: getAppetiteSelectValue(sub.Appetite) || sub.Appetite,
          })),
        }))
      );
    } else {
      setTaxonomy({
        id: uuidv4(),
        Taxo_Name: "",
        Taxo_Desc: "",
        countryCode: "",
        evaluationPeriod: "1 year",
      });
      setCategories([
        {
          id: uuidv4(),
          name: "",
          Owner: "",
          desc: "",
          SubCategories: [
            {
              id: uuidv4(), // Add a UUID property to the subcategory object
              name: "",
              Appetite: "",
              Owner: "",
              Description: "",
            },
          ],
        },
      ]);
    }
  }, [SingleTaxonomy]);

  const [ownerUsers, setOwnerUsers] = useState([]);
  const ownerUsersFetched = useRef(false);

  useEffect(() => {
    if (ownerUsersFetched.current) return;
    ownerUsersFetched.current = true;
    execute("GET", `${protectedResources.apiTodoList.endpoint}/users/list-for-owners`).then(
      (response) => {
        if (response?.data && Array.isArray(response.data)) {
          setOwnerUsers(response.data);
        }
      }
    );
  }, [execute]);
  // card click on review page

  const [clickedId, setClickedId] = useState(null);
  const [validationAlertMessage, setValidationAlertMessage] = useState("");
  // take input/edit input for primary and sub category
  // Resolve which category an edit targets. A stable `categoryId` (passed by the tabbed edit view)
  // ALWAYS wins so a stale `clickedId` can never redirect edits to the wrong category. Otherwise fall
  // back to the clicked card, the single-category edit id, then the explicit row index.
  const resolveCategoryIndex = (categories, categoryIndex, categoryId) => {
    if (categoryId) {
      const i = categories.findIndex((c) => c.id === categoryId);
      if (i !== -1) return i;
    }
    if (clickedId) {
      const i = categories.findIndex((c) => c.id === clickedId);
      if (i !== -1) return i;
    }
    if (Primaryid) {
      const i = categories.findIndex((c) => c.id === Primaryid);
      if (i !== -1) return i;
    }
    return typeof categoryIndex === "number" ? categoryIndex : -1;
  };

  const handleInputChange = (categoryIndex, subCategoryIndex, field, value, categoryId) => {
    setValidationAlertMessage("");
    setCategories((prevState) => {
      const updatedCategories = [...prevState];
      const idx = resolveCategoryIndex(updatedCategories, categoryIndex, categoryId);
      if (idx < 0 || idx >= updatedCategories.length) return prevState;
      const updatedCategory = { ...updatedCategories[idx] };
      if (subCategoryIndex !== null && subCategoryIndex !== undefined) {
        const subs = [...(updatedCategory.SubCategories || [])];
        subs[subCategoryIndex] = { ...subs[subCategoryIndex], [field]: value };
        updatedCategory.SubCategories = subs;
      } else {
        updatedCategory[field] = value;
      }
      updatedCategories[idx] = updatedCategory;
      return updatedCategories;
    });
  };

  const [categoryTab, setCategoryTab] = useState(0);
  const [deleteConfirm, setDeleteConfirm] = useState(null); // { type: 'category'|'subcategory', categoryIndex, subCategoryIndex?, extraAction? }

  useEffect(() => {
    if (Categories.length > 0 && categoryTab >= Categories.length) {
      setCategoryTab(Math.max(0, Categories.length - 1));
    }
  }, [Categories.length, categoryTab]);

  //  add category (new primary risk)
  const handleAddCategory = () => {
    if (!Primaryid) {
      setCategories((prevState) => {
        const updatedCategories = [...prevState];
        const newCategory = {
          id: uuidv4(),
          name: "",
          Owner: "",
          desc: "",
          SubCategories: [
            {
              id: uuidv4(),
              name: "",
              Appetite: "",
              Owner: "",
              Description: "",
            },
          ],
        };
        updatedCategories.push(newCategory);

        return updatedCategories;
      });
    } else {
      setCategories((prevState) => {
        const updatedCategories = [...prevState];
        const newCategory = {
          id: uuidv4(),
          name: "",
          Owner: "",
          desc: "",
          SubCategories: [
            {
              id: uuidv4(),
              name: "",
              Appetite: "",
              Owner: "",
              Description: "",
            },
          ],
        };
        updatedCategories.push(newCategory);

        return updatedCategories;
      });
    }
    // Clear any stale "clicked card" selection so edits to the new category target it by index
    // rather than being misrouted to a previously-clicked category (caused Appetite/Description to
    // silently land on the wrong category and fail validation).
    setClickedId(null);
    // Jump to the newly-added category's tab so the user edits the one they just created (its index
    // is the current length, before the state update appends it).
    setCategoryTab(Categories.length);
  };

  //   delete a category (delete primary risk)===============================

  const handleDeleteCategory = (categoryIndex) => {
    // Delete the EXACT category the user clicked. Resolve it by its stable id (from the clicked row's
    // index) rather than a stale `clickedId` — that fallback caused the wrong (usually first) category
    // to be removed after adding a new one. Falls back to the raw index only if the id can't be found.
    const target = Categories[categoryIndex];
    setCategories((prevState) => {
      if (target?.id) {
        const idx = prevState.findIndex((category) => category.id === target.id);
        if (idx !== -1) return prevState.filter((_, i) => i !== idx);
      }
      return prevState.filter((_, i) => i !== categoryIndex);
    });
  };

  // add sub category (add risk sub category)

  const handleAddSubCategory = (categoryIndex, categoryId) => {
    setCategories((prevState) => {
      const updatedCategories = [...prevState];
      const idx = resolveCategoryIndex(updatedCategories, categoryIndex, categoryId);
      if (idx < 0 || idx >= updatedCategories.length) return prevState;
      const target = { ...updatedCategories[idx] };
      target.SubCategories = [
        ...(target.SubCategories || []),
        { id: uuidv4(), name: "", Appetite: "", Owner: "", Description: "" },
      ];
      updatedCategories[idx] = target;
      return updatedCategories;
    });
  };

  const handleDeleteSubCategory = (categoryIndex, subCategoryIndex, categoryId) => {
    setCategories((prevState) => {
      const updatedCategories = [...prevState];
      const idx = resolveCategoryIndex(updatedCategories, categoryIndex, categoryId);
      if (idx < 0 || idx >= updatedCategories.length) return prevState;
      const target = { ...updatedCategories[idx] };
      target.SubCategories = (target.SubCategories || []).filter((_, i) => i !== subCategoryIndex);
      updatedCategories[idx] = target;
      return updatedCategories;
    });
  };

  // Take inputs of Taxonomy details
  const handleTaxonomyChange = (event) => {
    setValidationAlertMessage("");
    const { name, value } = event.target;
    setTaxonomy((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [activeStep, setActiveStep] = React.useState(0);
  // const [completed, setCompleted] = React.useState({});

  const handleCardClick = (cardId) => {
    // Find the clicked object from the Categories array using the id
    setClickedId(cardId);

    setActiveStep(1);
  };

  // -----------------------------------------Validations-------------------------------------------------------------------
  //  Taxonomy step 1 validation
  const [formErrors, setFormErrors] = useState({
    Taxo_Name: "",
    Taxo_Desc: "",
    Taxo_curr: "",
  });

  const validateTaxonomyFields = () => {
    let isValid = true;
    const errors = {};
    const messages = [];

    // Validate Taxonomy Name
    if (!Taxonomy.Taxo_Name) {
      isValid = false;
      errors.Taxo_Name = "Taxonomy Name is required";
      messages.push(errors.Taxo_Name);
    } else if (Taxonomy.Taxo_Name.length < 10) {
      isValid = false;
      errors.Taxo_Name = "Taxonomy Name must be greater than 10 characters";
      messages.push(errors.Taxo_Name);
    } else if (/[^\w\s]/.test(Taxonomy.Taxo_Name)) {
      isValid = false;
      errors.Taxo_Name = "Taxonomy Name should not contain special characters";
      messages.push(errors.Taxo_Name);
    }
    if (!Taxonomy.countryCode) {
      isValid = false;
      errors.Taxo_curr = "Currency is required";
      messages.push(errors.Taxo_curr);
    }

    setFormErrors(errors);
    return { isValid, message: messages.join(". ") };
  };
  // ----------------------------------------------------------------------------
  // step2 validation

  const [categoriesErrors, setCategoriesErrors] = useState([]);

  const validateCategories = () => {
    let isValid = true;
    const errors = [];
    const messageParts = [];
    let firstErrorIndex = -1; // first category (by index) with any problem — used to auto-focus it

    // Build a per-category summary that NAMES the category, so the alert tells the user exactly which
    // tab(s) to fix (validation runs across every category, not just the one being edited).
    const summarizeCategory = (category, errObj) => {
      const problems = [];
      if (errObj.name) problems.push("category name");
      if (errObj.desc) problems.push("category description");
      if (errObj.Owner) problems.push("owner");
      let incompleteSubs = 0;
      (errObj.subCategories || []).forEach((sc) => {
        if (sc && (sc.name || sc.Appetite || sc.Description)) incompleteSubs += 1;
      });
      if (incompleteSubs) {
        problems.push(
          `${incompleteSubs} sub-categor${incompleteSubs === 1 ? "y" : "ies"} incomplete`
        );
      }
      if (!problems.length) return null;
      return `${category?.name?.trim() || "Unnamed category"} — ${problems.join(", ")}`;
    };

    if (Primaryid) {
      Categories.forEach((category, categoryIndex) => {
        if (category.id !== Primaryid) return;
        const categoryErrors = {
          name: "",
          desc: "",
          Owner: "",
          subCategories: [],
        };

        // Validate category name
        if (!category.name) {
          isValid = false;
          categoryErrors.name = "Category name is required";
        } else if (category.name.length < 10) {
          isValid = false;
          categoryErrors.name = "Category name must be greater than 10 characters";
        } else {
          categoryErrors.name = ""; // Clear the error if the name is filled
        }

        // Validate category description
        if (!category.desc) {
          isValid = false;
          categoryErrors.desc = "Category description is required";
        } else if (category.desc.length < 20) {
          isValid = false;
          categoryErrors.desc = "Category description must be greater than 20 characters";
        } else if (category.desc.length > 200) {
          isValid = false;
          categoryErrors.desc = "Category description must be less than 200 characters";
        } else {
          categoryErrors.desc = ""; // Clear the error if the name is filled
        }

        // Validate Level 1 owner (TX-04)
        if (!category.Owner || !String(category.Owner).trim()) {
          isValid = false;
          categoryErrors.Owner = "Owner is required for Level 1 category";
        } else {
          categoryErrors.Owner = "";
        }

        category.SubCategories.forEach((subCategory, subCategoryIndex) => {
          const subCategoryErrors = {
            name: "",
            Appetite: "",
            Owner: "",
            Description: "",
          };

          // Validate subcategory name
          if (!subCategory.name) {
            isValid = false;
            subCategoryErrors.name = "Subcategory name is required";
          } else if (subCategory.name.length < 10) {
            isValid = false;
            subCategoryErrors.name = "Subcategory name must be greater than 10 characters";
          } else {
            subCategoryErrors.name = ""; // Clear the error if the name is filled
          }

          // Validate subcategory appetite (4-point scale)
          if (!subCategory.Appetite) {
            isValid = false;
            subCategoryErrors.Appetite = "Appetite is required";
          } else if (!resolveAppetiteOption(subCategory.Appetite)) {
            isValid = false;
            subCategoryErrors.Appetite = `Appetite must be one of: ${appetiteOptions.join(", ")}`;
          }

          // Validate subcategory description
          if (!subCategory.Description) {
            isValid = false;
            subCategoryErrors.Description = "Description is required";
          } else if (subCategory.Description.length < 20) {
            isValid = false;
            subCategoryErrors.Description = "Description must be at least 20 characters";
          }

          categoryErrors.subCategories[subCategoryIndex] = subCategoryErrors;
        });

        errors[categoryIndex] = categoryErrors;
        {
          const summary = summarizeCategory(category, categoryErrors);
          if (summary) {
            if (firstErrorIndex === -1) firstErrorIndex = categoryIndex;
            messageParts.push(summary);
          }
        }
      });
    } else {
      Categories.forEach((category, categoryIndex) => {
        const categoryErrors = {
          name: "",
          desc: "",
          Owner: "",
          subCategories: [],
        };

        // Validate category name
        if (!category.name) {
          isValid = false;
          categoryErrors.name = "Category name is required";
        } else if (category.name.length < 10) {
          isValid = false;
          categoryErrors.name = "Category name must be greater than 10 characters";
        } else {
          categoryErrors.name = ""; // Clear the error if the name is filled
        }

        // Validate category description
        if (!category.desc) {
          isValid = false;
          categoryErrors.desc = "Category description is required";
        } else if (category.desc.length < 20) {
          isValid = false;
          categoryErrors.desc = "Category description must be greater than 20 characters";
        } else if (category.desc.length > 200) {
          isValid = false;
          categoryErrors.desc = "Category description must be less than 200 characters";
        } else {
          categoryErrors.desc = ""; // Clear the error if the name is filled
        }

        // Validate Level 1 owner (TX-04)
        if (!category.Owner || !String(category.Owner).trim()) {
          isValid = false;
          categoryErrors.Owner = "Owner is required for Level 1 category";
        } else {
          categoryErrors.Owner = "";
        }

        category.SubCategories.forEach((subCategory, subCategoryIndex) => {
          const subCategoryErrors = {
            name: "",
            Appetite: "",
            Owner: "",
            Description: "",
          };

          // Validate subcategory name
          if (!subCategory.name) {
            isValid = false;
            subCategoryErrors.name = "Subcategory name is required";
          } else if (subCategory.name.length < 10) {
            isValid = false;
            subCategoryErrors.name = "subcategory name must be greater than 10 characters";
          } else {
            subCategoryErrors.name = ""; // Clear the error if the name is filled
          }

          // Validate subcategory appetite (4-point scale)
          if (!subCategory.Appetite) {
            isValid = false;
            subCategoryErrors.Appetite = "Appetite is required";
          } else if (!resolveAppetiteOption(subCategory.Appetite)) {
            isValid = false;
            subCategoryErrors.Appetite = `Appetite must be one of: ${appetiteOptions.join(", ")}`;
          }

          // Validate subcategory description
          if (!subCategory.Description) {
            isValid = false;
            subCategoryErrors.Description = "Description is required";
          } else if (subCategory.Description.length < 20) {
            isValid = false;
            subCategoryErrors.Description = "Description must be at least 20 characters";
          }

          categoryErrors.subCategories[subCategoryIndex] = subCategoryErrors;
        });

        errors[categoryIndex] = categoryErrors;
        {
          const summary = summarizeCategory(category, categoryErrors);
          if (summary) {
            if (firstErrorIndex === -1) firstErrorIndex = categoryIndex;
            messageParts.push(summary);
          }
        }
      });
    }

    setCategoriesErrors(errors);
    const message = messageParts.length
      ? `Please complete: ${messageParts.slice(0, 8).join(" · ")}`
      : "";
    return { isValid, message, firstErrorIndex };
  };

  // ==========================save dialog box===========================

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleSave = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    navigate("/Taxonomy");
  };

  const formTopRef = useRef(null);

  // ── ID38: Save as draft ──────────────────────────────────────────────────────
  // Persist partial work at any step. The first draft-save of a NEW taxonomy creates the record
  // and we remember its id so later saves update the same draft (no duplicates).
  const [savedTaxonomyId, setSavedTaxonomyId] = useState(Tid || null);
  const [savingDraft, setSavingDraft] = useState(false);
  const [draftSnack, setDraftSnack] = useState(null); // { message, severity }

  const buildRequestBody = (status) => {
    const normalizedCategories = Categories.map((cat) => ({
      ...cat,
      SubCategories: (cat.SubCategories || []).map((sub) => ({
        ...sub,
        Appetite: getAppetiteSelectValue(sub.Appetite) || sub.Appetite,
      })),
    }));
    return {
      name: Taxonomy.Taxo_Name,
      description: Taxonomy.Taxo_Desc,
      countryCode: Taxonomy.countryCode,
      evaluationPeriod: "1 year",
      Categories: normalizedCategories,
      status,
    };
  };

  const saveDraft = async () => {
    // Minimal guard — a draft just needs a name so it can be found again.
    if (!Taxonomy.Taxo_Name || !String(Taxonomy.Taxo_Name).trim()) {
      setValidationAlertMessage("Add a taxonomy name before saving a draft.");
      formTopRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    setSavingDraft(true);
    try {
      const body = buildRequestBody("draft");
      const targetId = savedTaxonomyId || Tid;
      const res = targetId
        ? await execute(
            "PUT",
            `${protectedResources.apiTodoList.endpoint}/taxonomy/update/${targetId}`,
            body
          )
        : await execute("POST", `${protectedResources.apiTodoList.endpoint}/taxonomy/create`, body);
      if (res && res.success === true) {
        // Capture the new draft's id so subsequent saves update it instead of creating duplicates.
        const newId = res.data?.id;
        if (!targetId && newId) setSavedTaxonomyId(String(newId));
        setValidationAlertMessage("");
        setDraftSnack({ message: "Draft saved.", severity: "success" });
      } else {
        setDraftSnack({ message: res?.message || "Could not save draft.", severity: "error" });
      }
    } catch (err) {
      setDraftSnack({ message: "Could not save draft.", severity: "error" });
    } finally {
      setSavingDraft(false);
    }
  };

  // =======================POst data to api=====================================
  const postData = async () => {
    // Final guard — re-validate categories before saving
    const preCheck = validateCategories();
    if (!preCheck.isValid) {
      setValidationAlertMessage(preCheck.message || "Please fix the errors before saving.");
      if (preCheck.firstErrorIndex >= 0) {
        setClickedId(null);
        setCategoryTab(preCheck.firstErrorIndex);
      }
      formTopRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    // Publish (full validation runs server-side). status:'published' also promotes a draft.
    const requestBody = buildRequestBody("published");
    // If this taxonomy was already saved as a draft this session, finalise THAT record.
    const updateId = Tid || savedTaxonomyId;

    try {
      const res = updateId
        ? await execute(
            "PUT",
            `${protectedResources.apiTodoList.endpoint}/taxonomy/update/${updateId}`,
            requestBody
          )
        : await execute(
            "POST",
            `${protectedResources.apiTodoList.endpoint}/taxonomy/create`,
            requestBody
          );
      // Only show "Saved" when the server actually saved. Previously this fired regardless, so a
      // server rejection (e.g. validation) silently looked successful while nothing was persisted.
      if (res && res.success === true) {
        handleSave();
      } else {
        setValidationAlertMessage(
          res?.message || "Could not save the taxonomy. Please review the fields and try again."
        );
        formTopRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } catch (err) {
      setValidationAlertMessage("Could not save the taxonomy. Please try again.");
      formTopRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // --------------------Stepper---------------------------------------------------------------------------------------------

  // go to next step
  useEffect(() => {
    if (Primaryid) {
      setActiveStep(1);
    }
  }, [Primaryid]);

  const handleNext = () => {
    let isValid = true;
    let message = "";

    if (activeStep === 0) {
      const result = validateTaxonomyFields();
      isValid = result.isValid;
      message = result.message || "";
    }

    let focusIndex = -1;
    if (activeStep === 1) {
      const result = validateCategories();
      isValid = result.isValid;
      message = result.message || "";
      focusIndex = result.firstErrorIndex;
    }

    if (isValid) {
      setValidationAlertMessage("");
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setValidationAlertMessage(message);
      // Jump to the first category that has an error so the user lands on the fields to fix.
      if (focusIndex >= 0) {
        setClickedId(null);
        setCategoryTab(focusIndex);
      }
      formTopRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setClickedId(null);
    if (activeStep === 0) {
      navigate("/Taxonomy");
    }
    if (activeStep === 1 && Primaryid) {
      navigate("/Taxonomy");
    }
    if (Primaryid && clickedId && activeStep === 1) {
      // setActiveStep((prevActiveStep) => prevActiveStep - 1);
      setActiveStep(2);
    }
    if (clickedId && activeStep === 2) {
      setActiveStep(1);
    }
  };

  // add primary key button on review page
  const categoriesContainerRef = useRef(null);

  const [scroll, setScroll] = useState(false);
  const handleAddKey = () => {
    setScroll(true);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setClickedId(null);
    handleAddCategory();
  };
  useEffect(() => {
    const lastChildElement = categoriesContainerRef.current?.lastElementChild;
    lastChildElement?.scrollIntoView({ behavior: "smooth" });

    setScroll(false);
  }, [scroll]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <form onSubmit={(e) => e.preventDefault()}>
        <Grid
          ref={formTopRef}
          style={{
            backgroundColor: "white",
            borderRadius: "5px",
            padding: "15px",
            minHeight: "520px",
          }}
        >
          <Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ mb: "10px" }}>
            <Link to="/Taxonomy" underline="hover" color="inherit">
              <span className="breadcrumb-span"> Taxonomy </span>
            </Link>
            <span style={{ fontSize: "15px", color: "#8090AA" }}>Configure Taxonomy</span>
          </Breadcrumbs>
          {validationAlertMessage && (
            <MDAlert color="error" dismissible onClose={() => setValidationAlertMessage("")}>
              {validationAlertMessage}
            </MDAlert>
          )}
          <Typography sx={{ pb: "5px", fontWeight: 500 }} fontSize="21px">
            Configure Taxonomy
          </Typography>
          <hr style={{ border: "1px solid #B5BFD0" }} />

          {/* --------------Stepper UI --------------------------------------------------------*/}
          <Stepper
            activeStep={activeStep}
            sx={{ p: "20px", pb: "35px", pl: "12%", pr: "12%", textAlign: "center" }}
          >
            {steps.map((label) => {
              const stepProps = {};
              const labelProps = {};

              return (
                <Step key={label} {...stepProps}>
                  <StepLabel sx={{ fontSize: "15px" }} {...labelProps}>
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>

          {/* Action bar kept at the top (sticky) so Cancel / Save as draft / Next-Save are always
              visible without scrolling to the bottom of a long taxonomy. */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 20,
              bgcolor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 2,
              py: 1.5,
              mb: 1.5,
              borderBottom: "1.5px solid #B5BFD0",
            }}
          >
            <MDButton
              type="button"
              color="black"
              variant="outlined"
              onClick={handleBack}
              sx={{
                color: "#263445",
                border: "1px solid #B5BFD0",
                textTransform: "none",
                borderRadius: "4px",
                fontSize: "15px",
                height: "36px",
              }}
            >
              Cancel
            </MDButton>
            {!Tid && !Primaryid && (
              <MDButton
                type="button"
                onClick={saveDraft}
                disabled={savingDraft}
                variant="outlined"
                color="black"
                sx={{
                  color: "#402899",
                  border: "1px solid #402899",
                  textTransform: "none",
                  borderRadius: "4px",
                  fontSize: "15px",
                  height: "36px",
                }}
              >
                {savingDraft ? "Saving…" : "Save as draft"}
              </MDButton>
            )}
            <MDButton
              type="button"
              onClick={activeStep === steps.length - 1 ? postData : handleNext}
              variant="contained"
              color="#402899"
              sx={{
                color: "#f7f4fb",
                minWidth: "79px",
                height: "36px",
                borderRadius: "4px",
                textTransform: "none",
                fontSize: "15px",
              }}
            >
              {activeStep === steps.length - 1 ? "Save" : "Next"}
            </MDButton>
          </Box>

          <>
            {activeStep === 0 ? (
              // Taxonomy details=================================================

              <Grid container spacing={4} sx={{ pl: "8px", pb: "70px" }}>
                <Grid item md={12} sx={{ p: "5px" }} sm={12} xs={12} lg={12}>
                  <span className="tax-header">Taxonomy Details</span>
                  <h6 className="tax-subheader">
                    Decide the Taxonomy Name, Description and Relationship before adding the risks{" "}
                  </h6>
                </Grid>
                {/* check if taxonomy is present or not */}
                {noData === true ? (
                  <>
                    <Grid item md={12} sx={12} sm={12} xs={12} lg={12}>
                      <Stack direction="row" spacing={1}>
                        {/* taxonamy name field */}

                        <TextField
                          label="Taxonomy Name"
                          variant="outlined"
                          name="Taxo_Name"
                          sx={{ width: "280px", height: "49px" }}
                          value={Taxonomy.Taxo_Name || ""}
                          disabled={Isdisable}
                          onChange={handleTaxonomyChange}
                          required
                          error={!!formErrors.Taxo_Name}
                          helperText={formErrors.Taxo_Name}
                        />

                        {/* currency select box */}

                        <FormControl required>
                          <InputLabel id="Currency">Currency</InputLabel>

                          <Select
                            sx={{
                              width: "280px",
                              minHeight: 48,
                              // color: "black",
                            }}
                            label="Currency"
                            name="countryCode"
                            value={Taxonomy.countryCode || ""}
                            onChange={handleTaxonomyChange}
                            error={!!formErrors.Taxo_curr}
                            helperText={formErrors.Taxo_curr}
                          >
                            {currency &&
                              currency.map((option, index) => (
                                <MenuItem key={index} value={option.countryCode}>
                                  {option.countryName}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>

                        {/* ID3 — "Evaluation Period" dropdown removed (legacy, not relevant). */}
                      </Stack>
                    </Grid>
                    <Grid item md={12} sm={12} xs={12} lg={12}>
                      <TextField
                        label="Description"
                        sx={{ width: 520 }}
                        name="Taxo_Desc"
                        multiline
                        rows={3}
                        value={Taxonomy.Taxo_Desc || ""}
                        disabled={Isdisable}
                        onChange={handleTaxonomyChange}
                      />
                    </Grid>
                  </>
                ) : (
                  <>
                    {/* data is present from api */}
                    <Grid item md={12} sx={12} sm={12} xs={12} lg={12}>
                      <Stack direction="row" spacing={1}>
                        {/* taxonamy name field */}
                        {SingleTaxonomy ? (
                          <TextField
                            label="Taxonomy Name"
                            variant="outlined"
                            name="Taxo_Name"
                            sx={{ width: "280px", height: "49px" }}
                            value={Taxonomy.Taxo_Name || ""}
                            disabled={Isdisable}
                            onChange={handleTaxonomyChange}
                            required
                            error={!!formErrors.Taxo_Name}
                            helperText={formErrors.Taxo_Name}
                          />
                        ) : (
                          // <Skeleton variant="text" width={230} height={70} sx={{ mb: "15px" }} />
                          <Skeleton>
                            <TextField sx={{ width: 260, height: 49 }} />
                          </Skeleton>
                        )}
                        {/* currency select box */}
                        {SingleTaxonomy ? (
                          <FormControl required>
                            <InputLabel id="Currency">Currency</InputLabel>

                            <Select
                              sx={{
                                width: "280px",
                                minHeight: 48,
                              }}
                              label="Currency"
                              name="countryCode"
                              value={Taxonomy.countryCode || ""}
                              onChange={handleTaxonomyChange}
                              error={!!formErrors.Taxo_curr}
                              helperText={formErrors.Taxo_curr}
                            >
                              {currency &&
                                currency.map((option, index) => (
                                  <MenuItem key={index} value={option.countryCode}>
                                    {option.countryName}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        ) : (
                          // <Skeleton variant="text" width={230} height={70} sx={{ mb: "15px" }} />
                          <Skeleton>
                            <TextField sx={{ width: 260, height: 44 }} />
                          </Skeleton>
                        )}

                        {/* ID3 — "Evaluation Period" dropdown removed (legacy, not relevant). */}
                      </Stack>
                    </Grid>
                    <Grid item md={12} sm={12} xs={12} lg={12}>
                      {SingleTaxonomy ? (
                        <TextField
                          label="Description"
                          sx={{ width: 520 }}
                          name="Taxo_Desc"
                          multiline
                          rows={3}
                          value={Taxonomy.Taxo_Desc || ""}
                          disabled={Isdisable}
                          onChange={handleTaxonomyChange}
                        />
                      ) : (
                        // <Skeleton variant="text" width={230} height={70} sx={{ mb: "15px" }} />
                        <Skeleton>
                          <TextField sx={{ width: 520, height: 40 }} />
                        </Skeleton>
                      )}
                    </Grid>
                  </>
                )}
              </Grid>
            ) : (
              ""
            )}

            {activeStep === 1 ? (
              // Add-RIsk=================================================================================

              <Grid container spacing={1} sx={{ pl: "10px" }}>
                {noData ? (
                  <Grid item md={12} sm={12} xs={12} lg={12} sx={{ pb: "15px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <span className="tax-header">
                          Add Primary Risk Categories and Sub Categories
                        </span>
                        <h6 className="tax-subheader">
                          You can add a risk category and sub categories under it
                        </h6>
                      </div>
                      <div />
                    </div>
                  </Grid>
                ) : (
                  <Grid item md={12} sm={12} xs={12} lg={12} sx={{ pb: "15px" }}>
                    {SingleTaxonomy ? (
                      <span className="tax-header">
                        Add Primary Risk Categories and Sub Categories
                      </span>
                    ) : (
                      <Skeleton width={350} height={30} />
                    )}
                    {SingleTaxonomy ? (
                      <h6 className="tax-subheader">
                        You can add a risk category and sub categories under it
                      </h6>
                    ) : (
                      <Skeleton variant="text" width={330} height={20} />
                    )}
                  </Grid>
                )}

                {/* new taxonomy case */}
                {!clickedId &&
                  !Primaryid &&
                  !Tid &&
                  Categories &&
                  Categories.map((category, categoryIndex) => (
                    <Grid container spacing={1} ref={categoriesContainerRef}>
                      <Accordion sx={{ boxShadow: "none" }} defaultExpanded={categoryIndex === 0}>
                        <Grid
                          item
                          md={12}
                          sx={12}
                          lg={12}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            backgroundColor: "#F7F8FF",
                            paddingBottom: "6px",
                            margin: "20px",
                            height: "48px",
                            alignItems: "center",
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            sx={{
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                style={{ fontSize: "15px", fontWeight: 500, marginLeft: "12px" }}
                              >
                                Primary Risk Category {categoryIndex + 1}
                              </Typography>

                              <DeleteIcon
                                style={{ marginRight: "12px", cursor: "pointer" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteConfirm({ type: "category", categoryIndex });
                                }}
                              />
                            </div>
                          </AccordionSummary>
                        </Grid>
                        <AccordionDetails>
                          <Grid
                            item
                            md={12}
                            sm={12}
                            xs={12}
                            lg={12}
                            spacing={2}
                            sx={{ pl: "25px" }}
                          >
                            <Stack direction="row" spacing={2} sx={{ pb: "20px", pl: "19px" }}>
                              <TextField
                                label="Name of Primary Risk Category"
                                name="name"
                                value={category.name ?? ""}
                                multiline
                                rows={2}
                                onChange={(e) =>
                                  handleInputChange(categoryIndex, null, "name", e.target.value)
                                }
                                variant="outlined"
                                sx={{ width: 250 }}
                                required
                                error={
                                  categoriesErrors[categoryIndex]?.name &&
                                  !!categoriesErrors[categoryIndex].name
                                }
                                helperText={categoriesErrors[categoryIndex]?.name}
                              />
                              <FormControl required sx={{ minWidth: 250 }}>
                                <InputLabel id="owner-label">Owner (Level 1)</InputLabel>
                                <Select
                                  labelId="owner-label"
                                  label="Owner (Level 1)"
                                  value={getOwnerSelectValue(category.Owner, ownerUsers)}
                                  onChange={(e) =>
                                    handleInputChange(categoryIndex, null, "Owner", e.target.value)
                                  }
                                  error={
                                    categoriesErrors[categoryIndex]?.Owner &&
                                    !!categoriesErrors[categoryIndex].Owner
                                  }
                                >
                                  <MenuItem value="">
                                    <em>Select owner</em>
                                  </MenuItem>
                                  {ownerUsers.map((u) => (
                                    <MenuItem key={u.id || u.email} value={u.email}>
                                      {u.name || u.email} ({u.email})
                                    </MenuItem>
                                  ))}
                                </Select>
                                {categoriesErrors[categoryIndex]?.Owner && (
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    sx={{ mt: 0.5, display: "block" }}
                                  >
                                    {categoriesErrors[categoryIndex].Owner}
                                  </Typography>
                                )}
                              </FormControl>
                            </Stack>

                            <Grid item md={12} sm={12} xs={12} lg={12} sx={{ pl: "19px" }}>
                              <TextField
                                label="Definition of Primary Risk Category"
                                name="desc"
                                value={category.desc ?? ""}
                                multiline
                                rows={3}
                                onChange={(e) =>
                                  handleInputChange(categoryIndex, null, "desc", e.target.value)
                                }
                                sx={{ width: 520 }}
                                required
                                error={
                                  categoriesErrors[categoryIndex]?.desc &&
                                  !!categoriesErrors[categoryIndex].desc
                                }
                                helperText={categoriesErrors[categoryIndex]?.desc}
                              />
                            </Grid>
                          </Grid>

                          {/* ------Risk sub category-------------------- */}
                          <Grid container>
                            {category.SubCategories &&
                              category.SubCategories.map((subCategory, subCategoryIndex) => (
                                // <Grid item md={12} sm={12} xs={12} lg={12}>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                  <div style={{ width: "60px" }}>
                                    <span style={{ marginLeft: "54px" }} className="dividerCat" />
                                  </div>
                                  {/* ID13 — colour bar by risk appetite (risk-averse → opportunity) */}
                                  <div
                                    key={subCategoryIndex}
                                    style={{
                                      borderLeft: `6px solid ${appetiteColorFor(
                                        subCategory.Appetite
                                      )}`,
                                      paddingLeft: "12px",
                                      borderRadius: "2px",
                                    }}
                                  >
                                    <Grid container spacing={1}>
                                      <Grid
                                        item
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        lg={12}
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                          margin: "10px",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        <Stack direction="row">
                                          <hr
                                            style={{
                                              height: "1.5px",
                                              width: "45px",
                                              backgroundColor: "#8090AA",
                                              border: "none",
                                              marginTop: "10px",
                                            }}
                                          />

                                          <Typography
                                            style={{ fontSize: "17px", color: "#7354CB" }}
                                          >
                                            Risk Sub Category {subCategoryIndex + 1}
                                          </Typography>
                                        </Stack>

                                        <DeleteIcon
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setDeleteConfirm({
                                              type: "subcategory",
                                              categoryIndex,
                                              subCategoryIndex,
                                            });
                                          }}
                                        />
                                      </Grid>
                                      <Grid
                                        item
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        lg={12}
                                        sx={{ pl: "30px" }}
                                      >
                                        <Stack
                                          direction="row"
                                          spacing={2}
                                          sx={{ pb: "15px", pl: "30px" }}
                                        >
                                          <TextField
                                            label="Name of Risk Sub Category"
                                            name="name"
                                            value={subCategory.name ?? ""}
                                            multiline
                                            rows={2}
                                            onChange={(e) =>
                                              handleInputChange(
                                                categoryIndex,
                                                subCategoryIndex,
                                                "name",
                                                e.target.value
                                              )
                                            }
                                            variant="outlined"
                                            sx={{ width: 250 }}
                                            required
                                            error={
                                              categoriesErrors[categoryIndex]?.subCategories[
                                                subCategoryIndex
                                              ]?.name &&
                                              !!categoriesErrors[categoryIndex]?.subCategories[
                                                subCategoryIndex
                                              ].name
                                            }
                                            helperText={
                                              categoriesErrors[categoryIndex]?.subCategories[
                                                subCategoryIndex
                                              ]?.name
                                            }
                                          />

                                          <FormControl required>
                                            <InputLabel id="Appetite">Appetite</InputLabel>

                                            <Select
                                              sx={{
                                                width: 250,
                                                minHeight: 48,
                                                color: "black",
                                                // ID13 — colour-code by appetite (risk-averse → opportunity).
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                  borderLeftWidth: 6,
                                                  borderLeftColor: appetiteColorFor(
                                                    subCategory.Appetite
                                                  ),
                                                },
                                              }}
                                              label="Appetite"
                                              name="Appetite"
                                              value={resolveAppetiteOption(subCategory.Appetite)}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  categoryIndex,
                                                  subCategoryIndex,
                                                  "Appetite",
                                                  e.target.value
                                                )
                                              }
                                              error={
                                                categoriesErrors[categoryIndex]?.subCategories[
                                                  subCategoryIndex
                                                ]?.Appetite &&
                                                !!categoriesErrors[categoryIndex]?.subCategories[
                                                  subCategoryIndex
                                                ].Appetite
                                              }
                                              helperText={
                                                categoriesErrors[categoryIndex]?.subCategories[
                                                  subCategoryIndex
                                                ]?.Appetite
                                              }
                                            >
                                              {appetiteOptions.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                  {option}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                            {categoriesErrors[categoryIndex]?.subCategories[
                                              subCategoryIndex
                                            ]?.Appetite && (
                                              <FormHelperText error>
                                                {
                                                  categoriesErrors[categoryIndex].subCategories[
                                                    subCategoryIndex
                                                  ].Appetite
                                                }
                                              </FormHelperText>
                                            )}
                                          </FormControl>
                                        </Stack>
                                      </Grid>
                                      <Grid
                                        item
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        lg={12}
                                        sx={{ ml: "30px" }}
                                      >
                                        <TextField
                                          label="Description of Risk Sub Category"
                                          name="Description"
                                          value={subCategory.Description ?? ""}
                                          multiline
                                          rows={3}
                                          onChange={(e) =>
                                            handleInputChange(
                                              categoryIndex,
                                              subCategoryIndex,
                                              "Description",
                                              e.target.value
                                            )
                                          }
                                          sx={{ width: 520 }}
                                          required
                                          error={
                                            categoriesErrors[categoryIndex]?.subCategories[
                                              subCategoryIndex
                                            ]?.Description &&
                                            !!categoriesErrors[categoryIndex]?.subCategories[
                                              subCategoryIndex
                                            ].Description
                                          }
                                          helperText={
                                            categoriesErrors[categoryIndex]?.subCategories[
                                              subCategoryIndex
                                            ]?.Description
                                          }
                                        />

                                        <Divider
                                          sx={{
                                            m: "10px",
                                            borderWidth: "1.5px",
                                            color: "#B5BFD0",
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  </div>
                                </div>
                                // </Grid>
                              ))}

                            <Grid
                              item
                              md={12}
                              sm={12}
                              xs={12}
                              lg={12}
                              sx={{ ml: "45px", display: "flex", flexDirection: "row" }}
                            >
                              <div>
                                <span
                                  style={{ marginLeft: "9px", height: "21px" }}
                                  className="dividerCat"
                                />
                              </div>
                              <Stack direction="row" alignItems="center">
                                <hr
                                  style={{
                                    height: "1.5px",
                                    width: "45px",
                                    backgroundColor: "#8090AA",
                                    border: "none",
                                    // marginTop: "10px",
                                  }}
                                />
                                <Button
                                  variant="text"
                                  onClick={() => handleAddSubCategory(categoryIndex)}
                                  sx={{ color: "#7354CB", p: 0 }}
                                >
                                  +Add Risk Sub Category
                                </Button>
                              </Stack>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                        <Divider
                          sx={{
                            m: "10px",
                            borderWidth: "1.5px",
                            color: "black",
                            mt: "15px",
                            width: "100%",
                          }}
                        />
                      </Accordion>
                    </Grid>
                  ))}

                {
                  // check if card is clicked on review page and render only that caegory
                  clickedId ? (
                    Categories &&
                    Categories.filter((category) => category.id === clickedId).map(
                      (category, categoryIndex) => (
                        <Grid container spacing={1}>
                          <Accordion
                            sx={{ boxShadow: "none" }}
                            defaultExpanded={categoryIndex === 0}
                          >
                            <Grid
                              item
                              md={12}
                              sx={12}
                              lg={12}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                backgroundColor: "#F7F8FF",
                                paddingBottom: "6px",
                                margin: "20px",
                                height: "48px",
                              }}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                sx={{
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: 500,
                                      marginLeft: "12px",
                                    }}
                                  >
                                    Primary Risk Category
                                  </Typography>

                                  <DeleteIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setDeleteConfirm({ type: "category", categoryIndex });
                                    }}
                                    style={{ marginRight: "12px", cursor: "pointer" }}
                                  />
                                </div>
                              </AccordionSummary>
                            </Grid>
                            <AccordionDetails>
                              <Grid
                                item
                                md={12}
                                sm={12}
                                xs={12}
                                lg={12}
                                spacing={2}
                                sx={{ pl: "25px" }}
                              >
                                <Stack direction="row" spacing={2} sx={{ pb: "20px", pl: "19px" }}>
                                  <TextField
                                    label="Name of Primary Risk Category"
                                    name="name"
                                    value={category.name ?? ""}
                                    multiline
                                    rows={2}
                                    onChange={(e) =>
                                      handleInputChange(categoryIndex, null, "name", e.target.value)
                                    }
                                    variant="outlined"
                                    sx={{ width: 250 }}
                                    required
                                    error={
                                      categoriesErrors[categoryIndex]?.name &&
                                      !!categoriesErrors[categoryIndex].name
                                    }
                                    helperText={categoriesErrors[categoryIndex]?.name}
                                  />
                                  <FormControl required sx={{ minWidth: 250 }}>
                                    <InputLabel id="owner-label-edit">Owner (Level 1)</InputLabel>
                                    <Select
                                      labelId="owner-label-edit"
                                      label="Owner (Level 1)"
                                      value={getOwnerSelectValue(category.Owner, ownerUsers)}
                                      onChange={(e) =>
                                        handleInputChange(
                                          categoryIndex,
                                          null,
                                          "Owner",
                                          e.target.value
                                        )
                                      }
                                      error={
                                        categoriesErrors[categoryIndex]?.Owner &&
                                        !!categoriesErrors[categoryIndex].Owner
                                      }
                                    >
                                      <MenuItem value="">
                                        <em>Select owner</em>
                                      </MenuItem>
                                      {ownerUsers.map((u) => (
                                        <MenuItem key={u.id || u.email} value={u.email}>
                                          {u.name || u.email} ({u.email})
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    {categoriesErrors[categoryIndex]?.Owner && (
                                      <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ mt: 0.5, display: "block" }}
                                      >
                                        {categoriesErrors[categoryIndex].Owner}
                                      </Typography>
                                    )}
                                  </FormControl>
                                </Stack>

                                <Grid item md={12} sm={12} xs={12} lg={12} sx={{ pl: "19px" }}>
                                  <TextField
                                    label="Definition of Primary Risk Category"
                                    name="desc"
                                    value={category.desc ?? ""}
                                    multiline
                                    rows={3}
                                    onChange={(e) =>
                                      handleInputChange(categoryIndex, null, "desc", e.target.value)
                                    }
                                    sx={{ width: 520 }}
                                    required
                                    error={
                                      categoriesErrors[categoryIndex]?.desc &&
                                      !!categoriesErrors[categoryIndex].desc
                                    }
                                    helperText={categoriesErrors[categoryIndex]?.desc}
                                  />
                                </Grid>
                              </Grid>

                              {/* ------Risk sub category-------------------- */}

                              <Grid container>
                                {category.SubCategories &&
                                  category.SubCategories.map((subCategory, subCategoryIndex) => (
                                    // <Grid item md={12} sm={12} xs={12} lg={12}>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                      <div style={{ width: "60px" }}>
                                        <span
                                          style={{ marginLeft: "54px" }}
                                          className="dividerCat"
                                        />
                                      </div>
                                      <div key={subCategoryIndex}>
                                        <Grid container spacing={1}>
                                          <Grid
                                            item
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            lg={12}
                                            style={{
                                              display: "flex",
                                              flexDirection: "row",
                                              justifyContent: "space-between",
                                              margin: "10px",
                                              marginLeft: "0px",
                                            }}
                                          >
                                            <Stack direction="row">
                                              <hr
                                                style={{
                                                  height: "1.5px",
                                                  width: "45px",
                                                  backgroundColor: "#8090AA",
                                                  border: "none",
                                                  marginTop: "10px",
                                                }}
                                              />

                                              <Typography
                                                style={{ fontSize: "17px", color: "#7354CB" }}
                                              >
                                                Risk Sub Category {subCategoryIndex + 1}
                                              </Typography>
                                            </Stack>

                                            <DeleteIcon
                                              style={{ cursor: "pointer" }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setDeleteConfirm({
                                                  type: "subcategory",
                                                  categoryIndex,
                                                  subCategoryIndex,
                                                });
                                              }}
                                            />
                                          </Grid>
                                          <Grid
                                            item
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            lg={12}
                                            sx={{ pl: "30px" }}
                                          >
                                            <Stack
                                              direction="row"
                                              spacing={2}
                                              sx={{ pb: "15px", pl: "30px" }}
                                            >
                                              <TextField
                                                label="Name of Risk Sub Category"
                                                name="name"
                                                value={subCategory.name ?? ""}
                                                multiline
                                                rows={2}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    categoryIndex,
                                                    subCategoryIndex,
                                                    "name",
                                                    e.target.value
                                                  )
                                                }
                                                variant="outlined"
                                                sx={{ width: 250 }}
                                                required
                                                error={
                                                  categoriesErrors[categoryIndex]?.subCategories[
                                                    subCategoryIndex
                                                  ]?.name &&
                                                  !!categoriesErrors[categoryIndex]?.subCategories[
                                                    subCategoryIndex
                                                  ].name
                                                }
                                                helperText={
                                                  categoriesErrors[categoryIndex]?.subCategories[
                                                    subCategoryIndex
                                                  ]?.name
                                                }
                                              />

                                              <FormControl required>
                                                <InputLabel id="Appetite">Appetite</InputLabel>

                                                <Select
                                                  sx={{
                                                    width: 250,
                                                    minHeight: 48,
                                                    color: "black",
                                                  }}
                                                  label="Appetite"
                                                  name="Appetite"
                                                  value={getAppetiteSelectValue(
                                                    subCategory.Appetite
                                                  )}
                                                  onChange={(e) =>
                                                    handleInputChange(
                                                      categoryIndex,
                                                      subCategoryIndex,
                                                      "Appetite",
                                                      e.target.value
                                                    )
                                                  }
                                                  error={
                                                    categoriesErrors[categoryIndex]?.subCategories[
                                                      subCategoryIndex
                                                    ]?.Appetite &&
                                                    !!categoriesErrors[categoryIndex]
                                                      ?.subCategories[subCategoryIndex].Appetite
                                                  }
                                                  helperText={
                                                    categoriesErrors[categoryIndex]?.subCategories[
                                                      subCategoryIndex
                                                    ]?.Appetite
                                                  }
                                                >
                                                  {APPETITE_OPTIONS.map((option) => (
                                                    <MenuItem key={option} value={option}>
                                                      {option}
                                                    </MenuItem>
                                                  ))}
                                                </Select>
                                                {categoriesErrors[categoryIndex]?.subCategories[
                                                  subCategoryIndex
                                                ]?.Appetite && (
                                                  <FormHelperText error>
                                                    {
                                                      categoriesErrors[categoryIndex].subCategories[
                                                        subCategoryIndex
                                                      ].Appetite
                                                    }
                                                  </FormHelperText>
                                                )}
                                              </FormControl>
                                            </Stack>
                                          </Grid>
                                          <Grid
                                            item
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            lg={12}
                                            sx={{ ml: "30px" }}
                                          >
                                            <TextField
                                              label="Description of Risk Sub Category"
                                              name="Description"
                                              value={subCategory.Description ?? ""}
                                              multiline
                                              rows={3}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  categoryIndex,
                                                  subCategoryIndex,
                                                  "Description",
                                                  e.target.value
                                                )
                                              }
                                              sx={{ width: 520 }}
                                              required
                                              error={
                                                categoriesErrors[categoryIndex]?.subCategories[
                                                  subCategoryIndex
                                                ]?.Description &&
                                                !!categoriesErrors[categoryIndex]?.subCategories[
                                                  subCategoryIndex
                                                ].Description
                                              }
                                              helperText={
                                                categoriesErrors[categoryIndex]?.subCategories[
                                                  subCategoryIndex
                                                ]?.Description
                                              }
                                            />

                                            {/* <Divider
                                              sx={{
                                                m: "10px",
                                                borderWidth: "1px",
                                                color: "#B5BFD0",
                                              }}
                                            /> */}
                                          </Grid>
                                        </Grid>
                                      </div>
                                    </div>
                                    // </Grid>
                                  ))}
                                <Grid
                                  item
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  lg={12}
                                  sx={{ ml: "45px", display: "flex", flexDirection: "row" }}
                                >
                                  <div>
                                    <span
                                      style={{ marginLeft: "9px", height: "21px" }}
                                      className="dividerCat"
                                    />
                                  </div>
                                  <Stack direction="row" alignItems="center">
                                    <hr
                                      style={{
                                        height: "1.5px",
                                        width: "45px",
                                        backgroundColor: "#8090AA",
                                        border: "none",
                                        // marginTop: "10px",
                                      }}
                                    />
                                    <Button
                                      variant="text"
                                      onClick={() => handleAddSubCategory()}
                                      sx={{ color: "#7354CB", p: 0 }}
                                    >
                                      +Add Risk Sub Category
                                    </Button>
                                  </Stack>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                            <Divider
                              sx={{
                                m: "10px",
                                borderWidth: "1.5px",
                                color: "black",
                                mt: "15px",
                                width: "100%",
                              }}
                            />
                          </Accordion>
                        </Grid>
                      )
                    )
                  ) : // check if primary id is present then render only that category single category
                  Primaryid ? (
                    isLoading === false ? (
                      Categories &&
                      Categories.filter((category) => category.id === Primaryid).map(
                        (category, categoryIndex) => (
                          <Grid container spacing={1}>
                            <Accordion
                              sx={{ boxShadow: "none" }}
                              defaultExpanded={categoryIndex === 0}
                            >
                              {Categories ? (
                                <Grid
                                  item
                                  md={12}
                                  sx={12}
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    backgroundColor: "#F7F8FF",
                                    paddingBottom: "6px",
                                    margin: "20px",
                                    height: "48px",
                                    alignItems: "center",
                                  }}
                                >
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    sx={{
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Typography
                                        style={{
                                          fontSize: "15px",
                                          fontWeight: 500,
                                          marginLeft: "12px",
                                        }}
                                      >
                                        Primary Risk Category
                                      </Typography>

                                      <DeleteIcon
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setDeleteConfirm({ type: "category", categoryIndex });
                                        }}
                                        style={{ marginRight: "12px", cursor: "pointer" }}
                                      />
                                    </div>
                                  </AccordionSummary>
                                </Grid>
                              ) : (
                                <Skeleton variant="rectangular" width={260} height={40} />
                              )}
                              <AccordionDetails>
                                <Grid
                                  item
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  lg={12}
                                  spacing={2}
                                  sx={{ pl: "25px" }}
                                >
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{ pb: "20px", pl: "19px" }}
                                  >
                                    <TextField
                                      label="Name of Primary Risk Category"
                                      name="name"
                                      value={category.name}
                                      onChange={(e) =>
                                        handleInputChange(
                                          categoryIndex,
                                          null,
                                          "name",
                                          e.target.value
                                        )
                                      }
                                      multiline
                                      variant="outlined"
                                      sx={{ width: 250 }}
                                      required
                                      error={
                                        categoriesErrors[categoryIndex]?.name &&
                                        !!categoriesErrors[categoryIndex].name
                                      }
                                      helperText={categoriesErrors[categoryIndex]?.name}
                                    />
                                    <FormControl required sx={{ minWidth: 250 }}>
                                      <InputLabel id="owner-label-tid">Owner (Level 1)</InputLabel>
                                      <Select
                                        labelId="owner-label-tid"
                                        label="Owner (Level 1)"
                                        value={getOwnerSelectValue(category.Owner, ownerUsers)}
                                        onChange={(e) =>
                                          handleInputChange(
                                            categoryIndex,
                                            null,
                                            "Owner",
                                            e.target.value
                                          )
                                        }
                                        error={
                                          categoriesErrors[categoryIndex]?.Owner &&
                                          !!categoriesErrors[categoryIndex].Owner
                                        }
                                      >
                                        <MenuItem value="">
                                          <em>Select owner</em>
                                        </MenuItem>
                                        {ownerUsers.map((u) => (
                                          <MenuItem key={u.id || u.email} value={u.email}>
                                            {u.name || u.email} ({u.email})
                                          </MenuItem>
                                        ))}
                                      </Select>
                                      {categoriesErrors[categoryIndex]?.Owner && (
                                        <Typography
                                          variant="caption"
                                          color="error"
                                          sx={{ mt: 0.5, display: "block" }}
                                        >
                                          {categoriesErrors[categoryIndex].Owner}
                                        </Typography>
                                      )}
                                    </FormControl>
                                  </Stack>

                                  <Grid item md={12} sm={12} xs={12} lg={12} sx={{ pl: "19px" }}>
                                    <TextField
                                      label="Definition of Primary Risk Category"
                                      name="desc"
                                      value={category.desc ?? ""}
                                      multiline
                                      rows={3}
                                      onChange={(e) =>
                                        handleInputChange(
                                          categoryIndex,
                                          null,
                                          "desc",
                                          e.target.value
                                        )
                                      }
                                      sx={{ width: 520 }}
                                      required
                                      error={
                                        categoriesErrors[categoryIndex]?.desc &&
                                        !!categoriesErrors[categoryIndex].desc
                                      }
                                      helperText={categoriesErrors[categoryIndex]?.desc}
                                    />
                                  </Grid>
                                </Grid>

                                {/* ------Risk sub category-------------------- */}

                                <Grid container>
                                  {
                                    // primaryRisk.riskSubCategory.map((subCategory, subIndex) => (
                                    category.SubCategories &&
                                      category.SubCategories.map(
                                        (subCategory, subCategoryIndex) => (
                                          <div style={{ display: "flex", flexDirection: "row" }}>
                                            <div style={{ width: "60px" }}>
                                              <span
                                                style={{ marginLeft: "54px" }}
                                                className="dividerCat"
                                              />
                                            </div>
                                            <div key={subCategoryIndex}>
                                              <Grid container spacing={1}>
                                                <Grid
                                                  item
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  lg={12}
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    margin: "10px",
                                                    marginLeft: "0px",
                                                  }}
                                                >
                                                  <Stack direction="row">
                                                    <hr
                                                      style={{
                                                        height: "1.5px",
                                                        width: "45px",
                                                        backgroundColor: "#8090AA",
                                                        border: "none",
                                                        marginTop: "10px",
                                                      }}
                                                    />

                                                    <Typography
                                                      style={{ fontSize: "17px", color: "#7354CB" }}
                                                    >
                                                      Risk Sub Category {subCategoryIndex + 1}
                                                    </Typography>
                                                  </Stack>

                                                  <DeleteIcon
                                                    style={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      setDeleteConfirm({
                                                        type: "subcategory",
                                                        categoryIndex,
                                                        subCategoryIndex,
                                                      });
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid
                                                  item
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  lg={12}
                                                  sx={{ pl: "30px" }}
                                                >
                                                  <Stack
                                                    direction="row"
                                                    spacing={2}
                                                    sx={{ pb: "15px", pl: "30px" }}
                                                  >
                                                    <TextField
                                                      key={subCategory.id}
                                                      label="Name of Risk Sub Category"
                                                      name="name"
                                                      value={subCategory.name ?? ""}
                                                      multiline
                                                      rows={2}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          categoryIndex,
                                                          subCategoryIndex,
                                                          "name",
                                                          e.target.value
                                                        )
                                                      }
                                                      variant="outlined"
                                                      sx={{ width: 250 }}
                                                      required
                                                      error={
                                                        categoriesErrors[categoryIndex]
                                                          ?.subCategories[subCategoryIndex]?.name &&
                                                        !!categoriesErrors[categoryIndex]
                                                          ?.subCategories[subCategoryIndex].name
                                                      }
                                                      helperText={
                                                        categoriesErrors[categoryIndex]
                                                          ?.subCategories[subCategoryIndex]?.name
                                                      }
                                                    />

                                                    <FormControl required>
                                                      <InputLabel id="Appetite">
                                                        Appetite
                                                      </InputLabel>

                                                      <Select
                                                        sx={{
                                                          width: 250,
                                                          minHeight: 48,
                                                          color: "black",
                                                        }}
                                                        label="Appetite"
                                                        name="Appetite"
                                                        value={getAppetiteSelectValue(
                                                          subCategory.Appetite
                                                        )}
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            categoryIndex,
                                                            subCategoryIndex,
                                                            "Appetite",
                                                            e.target.value
                                                          )
                                                        }
                                                        error={
                                                          categoriesErrors[categoryIndex]
                                                            ?.subCategories[subCategoryIndex]
                                                            ?.Appetite &&
                                                          !!categoriesErrors[categoryIndex]
                                                            ?.subCategories[subCategoryIndex]
                                                            .Appetite
                                                        }
                                                        helperText={
                                                          categoriesErrors[categoryIndex]
                                                            ?.subCategories[subCategoryIndex]
                                                            ?.Appetite
                                                        }
                                                      >
                                                        {APPETITE_OPTIONS &&
                                                          APPETITE_OPTIONS.map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                              {option}
                                                            </MenuItem>
                                                          ))}
                                                      </Select>
                                                      {categoriesErrors[categoryIndex]
                                                        ?.subCategories[subCategoryIndex]
                                                        ?.Appetite && (
                                                        <FormHelperText error>
                                                          {
                                                            categoriesErrors[categoryIndex]
                                                              .subCategories[subCategoryIndex]
                                                              .Appetite
                                                          }
                                                        </FormHelperText>
                                                      )}
                                                    </FormControl>
                                                  </Stack>
                                                </Grid>
                                                <Grid
                                                  item
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  lg={12}
                                                  sx={{ ml: "30px" }}
                                                >
                                                  <TextField
                                                    label="Description of Risk Sub Category"
                                                    name="Description"
                                                    value={subCategory.Description ?? ""}
                                                    multiline
                                                    rows={3}
                                                    onChange={(e) =>
                                                      handleInputChange(
                                                        categoryIndex,
                                                        subCategoryIndex,
                                                        "Description",
                                                        e.target.value
                                                      )
                                                    }
                                                    sx={{ width: 520 }}
                                                    required
                                                    error={
                                                      categoriesErrors[categoryIndex]
                                                        ?.subCategories[subCategoryIndex]
                                                        ?.Description &&
                                                      !!categoriesErrors[categoryIndex]
                                                        ?.subCategories[subCategoryIndex]
                                                        .Description
                                                    }
                                                    helperText={
                                                      categoriesErrors[categoryIndex]
                                                        ?.subCategories[subCategoryIndex]
                                                        ?.Description
                                                    }
                                                  />

                                                  {/* <Divider
                                                    sx={{
                                                      m: "10px",
                                                      borderWidth: "1px",
                                                      color: "#B5BFD0",
                                                    }}
                                                  /> */}
                                                </Grid>
                                              </Grid>
                                            </div>
                                          </div>
                                        )
                                      )
                                  }
                                </Grid>
                                <Grid
                                  item
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  lg={12}
                                  sx={{ ml: "45px", display: "flex", flexDirection: "row" }}
                                >
                                  <div>
                                    <span
                                      style={{ marginLeft: "9px", height: "21px" }}
                                      className="dividerCat"
                                    />
                                  </div>
                                  <Stack direction="row" alignItems="center">
                                    <hr
                                      style={{
                                        height: "1.5px",
                                        width: "45px",
                                        backgroundColor: "#8090AA",
                                        border: "none",
                                        // marginTop: "10px",
                                      }}
                                    />
                                    <Button
                                      variant="text"
                                      onClick={() => handleAddSubCategory()}
                                      sx={{ color: "#7354CB", p: 0 }}
                                    >
                                      +Add Risk Sub Category
                                    </Button>
                                  </Stack>
                                </Grid>
                              </AccordionDetails>
                              {/* <Divider
                                sx={{
                                  m: "10px",
                                  borderWidth: "1.5px",
                                  color: "black",
                                  mt: "15px",
                                  width: "100%",
                                }}
                              /> */}
                            </Accordion>
                          </Grid>
                        )
                      )
                    ) : (
                      <>
                        <Skeleton
                          variant="text"
                          // sx={{ fontSize: "1rem" }}
                          width={940}
                          height={50}
                        />
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                          <Skeleton>
                            <TextField sx={{ width: 260, height: 40 }} />
                          </Skeleton>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                          <Skeleton>
                            <TextField sx={{ width: 520, height: 40 }} />
                          </Skeleton>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                          <Skeleton variant="text" width={330} height={20} />
                        </Grid>
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                          <Stack direction="row" spacing={2}>
                            <Skeleton>
                              <TextField sx={{ width: 260, height: 40 }} />
                            </Skeleton>
                            <Skeleton>
                              <TextField sx={{ width: 260, height: 40 }} />
                            </Skeleton>
                          </Stack>
                        </Grid>
                        <Skeleton
                          variant="text"
                          // sx={{ fontSize: "1rem" }}
                          width={520}
                          height={40}
                        />
                      </>
                    )
                  ) : // else it would be edit (edit taxonomy)
                  !Primaryid && Tid && isLoading === false ? (
                    Categories &&
                    Categories.length > 0 && (
                      <Grid container spacing={1} ref={categoriesContainerRef}>
                        {/* Category tab strip — scrollable, brand-styled, with a per-tab error dot,
                            a close (×) affordance and an inline "+ Add" at the end. */}
                        <Grid item md={12} sm={12} xs={12} sx={{ mb: 2 }}>
                          {/* Category selector — pills WRAP to multiple rows so every category is
                              visible at once (no cramped horizontal scroll). Red dot = has errors. */}
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              alignItems: "center",
                              gap: 1,
                              borderBottom: "1px solid #e0e0e0",
                              pb: 1.5,
                            }}
                          >
                            {Categories.map((cat, i) => {
                              const active = Math.min(categoryTab, Categories.length - 1) === i;
                              const err = categoriesErrors[i];
                              const hasError =
                                !!err &&
                                (!!err.name ||
                                  !!err.Owner ||
                                  !!err.desc ||
                                  (Array.isArray(err.subCategories) &&
                                    err.subCategories.some(
                                      (s) => s && (s.name || s.Appetite || s.Owner || s.Description)
                                    )));
                              return (
                                <Box
                                  key={cat.id || i}
                                  role="tab"
                                  aria-selected={active}
                                  onClick={() => {
                                    setClickedId(null);
                                    setCategoryTab(i);
                                  }}
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.75,
                                    px: 1.25,
                                    py: 0.5,
                                    borderRadius: "16px",
                                    cursor: "pointer",
                                    maxWidth: 240,
                                    fontSize: "0.8rem",
                                    fontWeight: active ? 700 : 500,
                                    color: active ? "#402899" : "#5b6472",
                                    border: active ? "1.5px solid #402899" : "1px solid #cfd3dc",
                                    bgcolor: active ? "rgba(64,40,153,0.08)" : "#fff",
                                    "&:hover": { borderColor: "#402899" },
                                  }}
                                >
                                  {hasError && (
                                    <Box
                                      component="span"
                                      sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        bgcolor: "#d32f2f",
                                        flexShrink: 0,
                                      }}
                                    />
                                  )}
                                  <Box
                                    component="span"
                                    sx={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {cat.name?.trim() || `Category ${i + 1}`}
                                  </Box>
                                  <Box
                                    component="span"
                                    role="button"
                                    aria-label="Delete this category"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setDeleteConfirm({
                                        type: "category",
                                        categoryIndex: i,
                                        extraAction: () =>
                                          setCategoryTab((prev) =>
                                            Math.max(0, Math.min(prev, Categories.length - 2))
                                          ),
                                      });
                                    }}
                                    sx={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: 16,
                                      height: 16,
                                      borderRadius: "50%",
                                      fontSize: 14,
                                      lineHeight: 1,
                                      color: "#90a4ae",
                                      flexShrink: 0,
                                      "&:hover": {
                                        bgcolor: "rgba(211,47,47,0.14)",
                                        color: "#d32f2f",
                                      },
                                    }}
                                  >
                                    ×
                                  </Box>
                                </Box>
                              );
                            })}
                            <Button
                              type="button"
                              variant="text"
                              onClick={handleAddCategory}
                              sx={{
                                color: "#402899",
                                textTransform: "none",
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                                fontWeight: 600,
                                minWidth: 0,
                              }}
                            >
                              + Add Category
                            </Button>
                          </Box>
                        </Grid>
                        {Categories.map((category, categoryIndex) => (
                          <Box
                            key={category.id || categoryIndex}
                            role="tabpanel"
                            hidden={categoryTab !== categoryIndex}
                            id={`edit-tabpanel-${categoryIndex}`}
                            aria-labelledby={`edit-tab-${categoryIndex}`}
                            sx={{
                              width: "100%",
                              // Fit the browser: override the fixed 250/520px field widths so every
                              // input flows with the available width and wraps instead of overflowing.
                              overflowX: "hidden",
                              "& .MuiTextField-root": { width: "100%", maxWidth: 460 },
                              "& .MuiFormControl-root": { width: "100%", maxWidth: 460 },
                              "& .MuiOutlinedInput-root": { width: "100%" },
                              "& .MuiStack-root": { flexWrap: "wrap", rowGap: 1.5 },
                              "& textarea": { width: "100%", boxSizing: "border-box" },
                              "& .MuiBox-root": { maxWidth: "100%" },
                            }}
                          >
                            {categoryTab === categoryIndex && (
                              <Grid container spacing={1}>
                                <Grid
                                  item
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    paddingBottom: "6px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <Typography style={{ fontSize: "15px", fontWeight: 500 }}>
                                    Primary Risk Category {categoryIndex + 1}
                                  </Typography>
                                  {/* Delete moved to the tab's × affordance. */}
                                </Grid>
                                <Grid
                                  item
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  lg={12}
                                  spacing={2}
                                  sx={{ pl: "25px" }}
                                >
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{ pb: "20px", pl: "19px" }}
                                  >
                                    <TextField
                                      label="Name of Primary Risk Category"
                                      name="name"
                                      value={category.name ?? ""}
                                      multiline
                                      rows={2}
                                      onChange={(e) =>
                                        handleInputChange(
                                          categoryIndex,
                                          null,
                                          "name",
                                          e.target.value
                                        )
                                      }
                                      variant="outlined"
                                      sx={{ width: 250 }}
                                      required
                                      error={
                                        categoriesErrors[categoryIndex]?.name &&
                                        !!categoriesErrors[categoryIndex].name
                                      }
                                      helperText={categoriesErrors[categoryIndex]?.name}
                                    />
                                    <FormControl required sx={{ minWidth: 250 }}>
                                      <InputLabel id={`owner-label-tid-${categoryIndex}`}>
                                        Owner (Level 1)
                                      </InputLabel>
                                      <Select
                                        labelId={`owner-label-tid-${categoryIndex}`}
                                        label="Owner (Level 1)"
                                        value={getOwnerSelectValue(category.Owner, ownerUsers)}
                                        onChange={(e) =>
                                          handleInputChange(
                                            categoryIndex,
                                            null,
                                            "Owner",
                                            e.target.value
                                          )
                                        }
                                        error={
                                          categoriesErrors[categoryIndex]?.Owner &&
                                          !!categoriesErrors[categoryIndex].Owner
                                        }
                                      >
                                        <MenuItem value="">
                                          <em>Select owner</em>
                                        </MenuItem>
                                        {ownerUsers.map((u) => (
                                          <MenuItem key={u.id || u.email} value={u.email}>
                                            {u.name || u.email} ({u.email})
                                          </MenuItem>
                                        ))}
                                      </Select>
                                      {categoriesErrors[categoryIndex]?.Owner && (
                                        <Typography
                                          variant="caption"
                                          color="error"
                                          sx={{ mt: 0.5, display: "block" }}
                                        >
                                          {categoriesErrors[categoryIndex].Owner}
                                        </Typography>
                                      )}
                                    </FormControl>
                                  </Stack>

                                  <Grid item md={12} sm={12} xs={12} lg={12} sx={{ pl: "19px" }}>
                                    <Box sx={{ width: 520 }}>
                                      <Typography
                                        component="label"
                                        variant="caption"
                                        sx={{
                                          display: "block",
                                          color: categoriesErrors[categoryIndex]?.desc
                                            ? "error.main"
                                            : "text.secondary",
                                          mb: 0.5,
                                        }}
                                      >
                                        Definition of Primary Risk Category
                                        {categoriesErrors[categoryIndex]?.desc && " *"}
                                      </Typography>
                                      <textarea
                                        rows={3}
                                        value={category.desc ?? ""}
                                        onChange={(e) =>
                                          handleInputChange(
                                            categoryIndex,
                                            null,
                                            "desc",
                                            e.target.value
                                          )
                                        }
                                        style={{
                                          width: "100%",
                                          padding: "16.5px 14px",
                                          fontSize: 16,
                                          fontFamily: "inherit",
                                          borderRadius: 4,
                                          border: categoriesErrors[categoryIndex]?.desc
                                            ? "1px solid #d32f2f"
                                            : "1px solid rgba(0,0,0,0.23)",
                                        }}
                                      />
                                      {categoriesErrors[categoryIndex]?.desc && (
                                        <Typography
                                          variant="caption"
                                          color="error"
                                          sx={{ mt: 0.5 }}
                                        >
                                          {categoriesErrors[categoryIndex].desc}
                                        </Typography>
                                      )}
                                    </Box>
                                  </Grid>
                                </Grid>

                                {/* ------Risk sub category-------------------- */}

                                <Grid container>
                                  {category.SubCategories &&
                                    category.SubCategories.map((subCategory, subCategoryIndex) => (
                                      <div
                                        key={subCategory.id || subCategoryIndex}
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          width: "100%",
                                        }}
                                      >
                                        <div style={{ width: "60px" }}>
                                          <span
                                            style={{ marginLeft: "54px" }}
                                            className="dividerCat"
                                          />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                          <Grid container spacing={1}>
                                            <Grid
                                              item
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              lg={12}
                                              style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                margin: "10px",
                                                marginLeft: "0px",
                                              }}
                                            >
                                              <Stack direction="row">
                                                <hr
                                                  style={{
                                                    height: "1.5px",
                                                    width: "45px",
                                                    backgroundColor: "#8090AA",
                                                    border: "none",
                                                    marginTop: "10px",
                                                  }}
                                                />
                                                <Typography
                                                  style={{ fontSize: "17px", color: "#7354CB" }}
                                                >
                                                  Risk Sub Category {subCategoryIndex + 1}
                                                </Typography>
                                              </Stack>

                                              <DeleteIcon
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setDeleteConfirm({
                                                    type: "subcategory",
                                                    categoryIndex,
                                                    subCategoryIndex,
                                                  });
                                                }}
                                              />
                                            </Grid>
                                            <Grid
                                              item
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              lg={12}
                                              sx={{ pl: "30px" }}
                                            >
                                              <Stack
                                                direction="row"
                                                spacing={2}
                                                sx={{ pb: "15px", pl: "30px" }}
                                              >
                                                <TextField
                                                  label="Name of Risk Sub Category"
                                                  name="name"
                                                  value={subCategory.name ?? ""}
                                                  multiline
                                                  rows={2}
                                                  onChange={(e) =>
                                                    handleInputChange(
                                                      categoryIndex,
                                                      subCategoryIndex,
                                                      "name",
                                                      e.target.value
                                                    )
                                                  }
                                                  variant="outlined"
                                                  sx={{ width: 250 }}
                                                  required
                                                  error={
                                                    categoriesErrors[categoryIndex]?.subCategories[
                                                      subCategoryIndex
                                                    ]?.name &&
                                                    !!categoriesErrors[categoryIndex]
                                                      ?.subCategories[subCategoryIndex].name
                                                  }
                                                  helperText={
                                                    categoriesErrors[categoryIndex]?.subCategories[
                                                      subCategoryIndex
                                                    ]?.name
                                                  }
                                                />

                                                <FormControl required>
                                                  <InputLabel id="Appetite">Appetite</InputLabel>
                                                  <Select
                                                    sx={{
                                                      width: 250,
                                                      minHeight: 48,
                                                      color: "black",
                                                    }}
                                                    label="Appetite"
                                                    name="Appetite"
                                                    value={resolveAppetiteOption(
                                                      subCategory.Appetite
                                                    )}
                                                    onChange={(e) =>
                                                      handleInputChange(
                                                        categoryIndex,
                                                        subCategoryIndex,
                                                        "Appetite",
                                                        e.target.value,
                                                        category.id
                                                      )
                                                    }
                                                    error={
                                                      categoriesErrors[categoryIndex]
                                                        ?.subCategories[subCategoryIndex]
                                                        ?.Appetite &&
                                                      !!categoriesErrors[categoryIndex]
                                                        ?.subCategories[subCategoryIndex].Appetite
                                                    }
                                                    helperText={
                                                      categoriesErrors[categoryIndex]
                                                        ?.subCategories[subCategoryIndex]?.Appetite
                                                    }
                                                  >
                                                    {appetiteOptions.map((option) => (
                                                      <MenuItem key={option} value={option}>
                                                        {option}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                  {categoriesErrors[categoryIndex]?.subCategories[
                                                    subCategoryIndex
                                                  ]?.Appetite && (
                                                    <FormHelperText error>
                                                      {
                                                        categoriesErrors[categoryIndex]
                                                          .subCategories[subCategoryIndex].Appetite
                                                      }
                                                    </FormHelperText>
                                                  )}
                                                </FormControl>
                                              </Stack>
                                            </Grid>
                                            <Grid
                                              item
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              lg={12}
                                              sx={{ ml: "30px" }}
                                            >
                                              <Box sx={{ width: 520 }}>
                                                <Typography
                                                  component="label"
                                                  variant="caption"
                                                  sx={{
                                                    display: "block",
                                                    color: categoriesErrors[categoryIndex]
                                                      ?.subCategories?.[subCategoryIndex]
                                                      ?.Description
                                                      ? "error.main"
                                                      : "text.secondary",
                                                    mb: 0.5,
                                                  }}
                                                >
                                                  Description of Risk Sub Category
                                                  {categoriesErrors[categoryIndex]?.subCategories?.[
                                                    subCategoryIndex
                                                  ]?.Description && " *"}
                                                </Typography>
                                                <textarea
                                                  rows={3}
                                                  value={subCategory.Description ?? ""}
                                                  onChange={(e) =>
                                                    handleInputChange(
                                                      categoryIndex,
                                                      subCategoryIndex,
                                                      "Description",
                                                      e.target.value
                                                    )
                                                  }
                                                  style={{
                                                    width: "100%",
                                                    padding: "16.5px 14px",
                                                    fontSize: 16,
                                                    fontFamily: "inherit",
                                                    borderRadius: 4,
                                                    border: categoriesErrors[categoryIndex]
                                                      ?.subCategories?.[subCategoryIndex]
                                                      ?.Description
                                                      ? "1px solid #d32f2f"
                                                      : "1px solid rgba(0,0,0,0.23)",
                                                  }}
                                                />
                                                {categoriesErrors[categoryIndex]?.subCategories?.[
                                                  subCategoryIndex
                                                ]?.Description && (
                                                  <Typography
                                                    variant="caption"
                                                    color="error"
                                                    sx={{ mt: 0.5 }}
                                                  >
                                                    {
                                                      categoriesErrors[categoryIndex]
                                                        ?.subCategories?.[subCategoryIndex]
                                                        ?.Description
                                                    }
                                                  </Typography>
                                                )}
                                              </Box>

                                              <Divider
                                                sx={{
                                                  m: "10px",
                                                  borderWidth: "1px",
                                                  color: "#B5BFD0",
                                                }}
                                              />
                                            </Grid>
                                          </Grid>
                                        </div>
                                      </div>
                                    ))}
                                  <Grid
                                    item
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    lg={12}
                                    sx={{ ml: "45px", display: "flex", flexDirection: "row" }}
                                  >
                                    <div>
                                      <span
                                        style={{ marginLeft: "9px", height: "21px" }}
                                        className="dividerCat"
                                      />
                                    </div>
                                    <Stack direction="row" alignItems="center">
                                      <hr
                                        style={{
                                          height: "1.5px",
                                          width: "45px",
                                          backgroundColor: "#8090AA",
                                          border: "none",
                                        }}
                                      />
                                      <Button
                                        variant="text"
                                        onClick={() => handleAddSubCategory(categoryIndex)}
                                        sx={{ color: "#7354CB", p: 0 }}
                                      >
                                        +Add Risk Sub Category
                                      </Button>
                                    </Stack>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          </Box>
                        ))}
                      </Grid>
                    )
                  ) : (
                    // add skeleton here
                    // <>
                    //   <Skeleton
                    //     variant="text"
                    //     // sx={{ fontSize: "1rem" }}
                    //     width={940}
                    //     height={50}
                    //   />
                    //   <Grid item md={12} sm={12} xs={12} lg={12}>
                    //     <Skeleton>
                    //       <TextField sx={{ width: 260, height: 40 }} />
                    //     </Skeleton>
                    //   </Grid>
                    //   <Grid item md={12} sm={12} xs={12} lg={12}>
                    //     <Skeleton>
                    //       <TextField sx={{ width: 520, height: 40 }} />
                    //     </Skeleton>
                    //   </Grid>
                    //   <Grid item md={12} sm={12} xs={12} lg={12}>
                    //     <Skeleton variant="text" width={330} height={20} />
                    //   </Grid>
                    //   <Grid item md={12} sm={12} xs={12} lg={12}>
                    //     <Stack direction="row" spacing={2}>
                    //       <Skeleton>
                    //         <TextField sx={{ width: 260, height: 40 }} />
                    //       </Skeleton>
                    //       <Skeleton>
                    //         <TextField sx={{ width: 260, height: 40 }} />
                    //       </Skeleton>
                    //     </Stack>
                    //   </Grid>
                    //   <Skeleton
                    //     variant="text"
                    //     // sx={{ fontSize: "1rem" }}
                    //     width={520}
                    //     height={40}
                    //   />
                    // </>
                    ""
                  )
                }
                <Grid
                  item
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {!clickedId && !Primaryid && !Tid && (
                    <Button
                      type="button"
                      variant="outlined"
                      style={{ color: "#464d60", fontWeight: "light" }}
                      onClick={handleAddCategory}
                      sx={{
                        borderColor: "#B5BFD0",
                        width: "231px",
                        borderRadius: "4px",
                        textTransform: "none",
                      }}
                    >
                      + Add Primary Category
                    </Button>
                  )}
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            {/* // Review and save ==================================== */}
            {activeStep === 2 ? (
              <Grid
                container
                sx={{ padding: "25px", paddingLeft: "12px" }}
                style={{ display: "flex" }}
              >
                <Grid item md={12} sm={12} xs={12}>
                  <span className="tax-header">Review and save</span>
                </Grid>
                <Grid item md={12}>
                  <h6 className="tax-subheader">
                    You can review the information added, go back to make changes or save the
                    information
                  </h6>
                </Grid>

                <Grid container item md={12} sx={{ mt: "30px", mb: "30px" }}>
                  <Grid item xs={4} sm={3} md={3}>
                    <Typography variant="subtitle1" color="#8090AA" fontSize="13px" align="left">
                      Taxonomy Name
                    </Typography>
                  </Grid>
                  <Grid item xs={8} sm={8} md={9}>
                    <Typography variant="subtitle1" color="#8090AA" align="left" fontSize="13px">
                      Description
                    </Typography>
                  </Grid>
                  <Grid item xs={4} sm={4} md={3} sx={{ alignItems: "flex-start" }}>
                    <Typography variant="body1" fontSize="15px" align="left">
                      {Taxonomy.Taxo_Name}
                    </Typography>
                  </Grid>
                  <Grid item xs={8} sm={8} md={9} sx={{ alignItems: "flex-start" }}>
                    <Typography variant="body1" fontSize="15px" align="left">
                      {Taxonomy.Taxo_Desc}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={{ xs: 2, md: 1 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                  {/* edit button review (single cat edit) */}
                  {Primaryid
                    ? Categories &&
                      Categories.filter((category) => category.id === Primaryid).map(
                        (category, categoryIndex) => (
                          <Grid item xs={6} sm={6} md={3} lg={3}>
                            <Card
                              key={categoryIndex}
                              sx={{
                                bgcolor: "background.paper",
                                boxShadow: 2,
                                borderRadius: 2,
                                minWidth: 220,
                                maxWidth: 230,
                                my: 2,
                                mr: 2,
                                height: 290,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-evenly",
                                  minHeight: "50px",
                                  position: "sticky",
                                  backgroundColor: "#F7F8FF",
                                }}
                              >
                                <div
                                  style={{ width: "35px", alignItems: "center", display: "flex" }}
                                >
                                  <AccountCircleOutlinedIcon
                                    style={{ fontSize: "40px", color: "#402899" }}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: 1,
                                    minWidth: 0,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      color: "#402899",
                                      lineHeight: "1.3",
                                    }}
                                  >
                                    {category.name}
                                  </span>
                                  {category.Owner && (
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "#666", fontSize: "11px" }}
                                    >
                                      {getOwnerDisplayName(category.Owner, ownerUsers)}
                                    </Typography>
                                  )}
                                </div>

                                <LightTooltip title={category.desc}>
                                  <InfoOutlinedIcon sx={{ color: "#402899" }} />
                                </LightTooltip>

                                <ModeEditOutlineOutlinedIcon
                                  style={{
                                    cursor: "pointer",
                                    paddingLeft: "4px",
                                    color: "#402899",
                                  }}
                                  onClick={() => handleCardClick(category.id)}
                                />
                              </div>
                              {/* <hr /> */}
                              <Divider sx={{ ml: "5px", mr: "5px" }} />
                              <div
                                style={{
                                  marginLeft: "7px",
                                  overflow: "auto", // Add overflow property to enable scrolling for the content below
                                  // height: "85%", // Set a fixed height for the scrollable content
                                  lineHeight: 1.2,
                                }}
                              >
                                {category.SubCategories.map((subCategory) => (
                                  <>
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        lineHeight: "1.9",
                                      }}
                                    >
                                      {subCategory.name}
                                    </span>
                                    <br />
                                  </>
                                ))}
                              </div>
                            </Card>
                          </Grid>
                        )
                      )
                    : // edit taxonomy button review
                      Categories &&
                      Categories.map((category, categoryIndex) => (
                        <Grid item xs={6} sm={6} md={3} lg={3}>
                          <Card
                            key={categoryIndex}
                            sx={{
                              bgcolor: "background.paper",
                              boxShadow: 2,
                              borderRadius: 2,
                              minWidth: 220,
                              maxWidth: 230,
                              my: 2,
                              mr: 2,
                              height: 290,
                              // maxHeight: 200,
                              // overflow: "auto", // Add overflow property to enable scrolling
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-evenly",
                                minHeight: "50px",
                                position: "sticky",
                                backgroundColor: "#F7F8FF",
                              }}
                            >
                              <div style={{ width: "35px", alignItems: "center", display: "flex" }}>
                                <AccountCircleOutlinedIcon
                                  style={{ fontSize: "40px", color: "#402899" }}
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  flex: 1,
                                  minWidth: 0,
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color: "#402899",
                                    lineHeight: "1.3",
                                  }}
                                >
                                  {category.name}
                                </span>
                                {category.Owner && (
                                  <Typography
                                    variant="caption"
                                    sx={{ color: "#666", fontSize: "11px" }}
                                  >
                                    {getOwnerDisplayName(category.Owner, ownerUsers)}
                                  </Typography>
                                )}
                              </div>
                              <LightTooltip title={category.desc}>
                                <InfoOutlinedIcon sx={{ color: "#402899" }} />
                              </LightTooltip>

                              <ModeEditOutlineOutlinedIcon
                                style={{ cursor: "pointer", paddingLeft: "4px", color: "#402899" }}
                                onClick={() => handleCardClick(category.id)}
                              />
                            </div>
                            {/* <hr /> */}
                            <Divider sx={{ ml: "5px", mr: "5px" }} />

                            <div
                              style={{
                                marginLeft: "7px",
                                overflow: "auto", // Add overflow property to enable scrolling for the content below
                                // height: "85%", // Set a fixed height for the scrollable content
                                lineHeight: 1.2,
                              }}
                            >
                              {category.SubCategories.map((subCategory) => (
                                <>
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      lineHeight: "1.9",
                                    }}
                                  >
                                    - {subCategory.name}
                                  </span>
                                  <br />
                                </>
                              ))}
                            </div>
                          </Card>
                        </Grid>
                      ))}

                  {/* new taxonomy case */}
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            <Grid container>
              {activeStep === 2 ? (
                <Grid item md={12} sx={{ display: "flex", justifyContent: "end" }}>
                  {!Primaryid && !Tid && (
                    <Button
                      variant="outlined"
                      style={{ color: "#464d60" }}
                      onClick={handleAddKey}
                      sx={{ borderColor: "#3d4458" }}
                    >
                      + Add Primary Category
                    </Button>
                  )}
                </Grid>
              ) : (
                ""
              )}
            </Grid>
          </>
        </Grid>
      </form>

      {/* ID38 — draft-save feedback */}
      <Snackbar
        open={!!draftSnack}
        autoHideDuration={3000}
        onClose={() => setDraftSnack(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setDraftSnack(null)}
          severity={draftSnack?.severity || "success"}
          sx={{ width: "100%" }}
        >
          {draftSnack?.message}
        </Alert>
      </Snackbar>

      {/* save dialog box */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Saved Successfully</DialogTitle>
        <DialogContent>{/* You can add additional content here if needed */}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete confirmation dialog ── */}
      <Dialog open={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: "#b71c1c", fontWeight: 700 }}>⚠ Caution</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ lineHeight: 1.7 }}>
            You are about to delete a risk category. <strong>This cannot be undone.</strong> All
            corresponding data feeds and workflows associated with this category will also be
            deleted and automatically re-mapped to the best-fit new category. Are you sure you want
            to proceed with the deletion?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <MDButton onClick={() => setDeleteConfirm(null)}>Cancel</MDButton>
          <MDButton
            variant="contained"
            color="error"
            onClick={() => {
              const { type, categoryIndex, subCategoryIndex, extraAction } = deleteConfirm;
              if (type === "category") {
                handleDeleteCategory(categoryIndex);
              } else {
                handleDeleteSubCategory(categoryIndex, subCategoryIndex);
              }
              extraAction?.();
              setDeleteConfirm(null);
            }}
          >
            Yes, delete
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default ConfigureTaxonomy;
